module.exports = __webpack_public_path__ + "img/off-track.1ff8dcc2.svg";